import React from 'react';
import ReactDOM from 'react-dom/client';
import { PublicClientApplication, EventType, AuthenticationResult } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './authConfig';
import App from './App';
// Tabler icon font — the `ti ti-*` classes used across the app.
import '@tabler/icons-webfont/dist/tabler-icons.min.css';
import './index.css';

// An MSAL sign-in popup returns to this origin with the auth response in the URL hash, and
// the opening window reads it from there. If the app booted inside the popup, its router
// would redirect "/" → "/portfolio" and wipe the hash first (hash_empty_error) — so inside
// the popup, render nothing. MSAL names its popups "msal.<…>".
const isMsalPopup = !!window.opener && window.opener !== window && window.name.startsWith('msal.');

const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload as AuthenticationResult;
    if (payload.account) {
      msalInstance.setActiveAccount(payload.account);
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

if (!isMsalPopup) msalInstance.initialize().then(() => {
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
  }

  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>
  );
});
